import React from "react";
import { Box, Typography } from "@mui/material";

import { translate } from "../../i18n";
import { RestartACR } from "./RestartACR";
import { ServerInfo } from "./ServerInfo";
import { BackupRestore } from "./BackupRestore";

export class ServerComponent extends React.Component {
   
  constructor(props: any) {
    super(props);
  }

  public render(): JSX.Element {
    return (
      <>       
        <Box margin={2} p={2} display="flex" flexDirection="column">          
            <ServerInfo/>
            <BackupRestore/>
            <Typography variant="h5" data-cy="maintenance-restart-title">{translate("Restart title")}</Typography>
            <RestartACR disabledButton={false} labelButton={translate("Restart")}/>
        </Box>
      </>
    );
  }
}
